import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tooltipFn = /* @__PURE__ */ createRecipe('tooltip', {
  "visual": "default",
  "horizontal": "left",
  "vertical": "bottom"
}, [])

const tooltipVariantMap = {
  "visual": [
    "default",
    "basic",
    "brand",
    "promo",
    "textSecondary"
  ],
  "horizontal": [
    "left",
    "center",
    "right"
  ],
  "vertical": [
    "top",
    "center",
    "bottom"
  ],
  "size": [
    "sm"
  ],
  "wrap": [
    "true"
  ]
}

const tooltipVariantKeys = Object.keys(tooltipVariantMap)

export const tooltip = /* @__PURE__ */ Object.assign(memo(tooltipFn), {
  __recipe__: true,
  __name__: 'tooltip',
  raw: (props) => props,
  variantKeys: tooltipVariantKeys,
  variantMap: tooltipVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tooltipVariantKeys)
  },
})